import React, { useState, useEffect } from "react";
import emailjs from "@emailjs/browser";
import "aos/dist/aos.css";

const ContactForm = () => {
  // Initialize EmailJS
  useEffect(() => {
    emailjs.init("hdefUFUPOXANkzTvY");
  }, []);
  const [formData, setFormData] = useState({
    fullName: "",
    email: "",
    phone: "",
    message: "",
  });

  const [status, setStatus] = useState(""); // To display success/error message
  const [isSubmitting, setIsSubmitting] = useState(false);

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value,
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsSubmitting(true);
    setStatus("");

    // Client-side validation
    if (
      !formData.fullName.trim() ||
      !formData.email.trim() ||
      !formData.phone.trim() ||
      !formData.message.trim()
    ) {
      setStatus("Please fill in all fields.");
      setIsSubmitting(false);
      return;
    }

    if (formData.phone.trim().length < 10) {
      setStatus("Phone number must be at least 10 characters long.");
      setIsSubmitting(false);
      return;
    }

    try {
      // Prepare the data to send
      const dataToSend = {
        ...formData,
        source: "website",
      };

      console.log("Sending data to backend:", dataToSend);

      // Submit to backend API
      const backendResponse = await fetch(
        "https://backend-service-11844559410.us-central1.run.app/api/contacts",
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify(dataToSend),
        }
      );

      console.log("Backend response status:", backendResponse.status);

      if (!backendResponse.ok) {
        const errorData = await backendResponse.json();
        console.error("Backend validation error:", errorData);
        console.error("Validation errors details:", errorData.errors);
        throw new Error(errorData.message || "Failed to submit to backend");
      }

      const responseData = await backendResponse.json();
      console.log("Backend response data:", responseData);

      // Also send via EmailJS for immediate email notification
      try {
        console.log("Sending EmailJS notification...");
        console.log("EmailJS config:", {
          serviceId: "service_51o83lp",
          templateId: "template_qor06dj",
          publicKey: "hdefUFUPOXANkzTvY",
          templateParams: {
            from_name: formData.fullName,
            name: formData.fullName,
            email: formData.email,
            phone: formData.phone,
            message: formData.message,
          },
        });

        const emailResponse = await emailjs.send(
          "service_51o83lp", // Replace with your EmailJS service ID
          "template_qor06dj", // Replace with your EmailJS template ID
          {
            from_name: formData.fullName,
            name: formData.fullName,
            email: formData.email,
            phone: formData.phone,
            message: formData.message,
          },
          "hdefUFUPOXANkzTvY" // Replace with your EmailJS public key
        );

        console.log(
          "EmailJS SUCCESS!",
          emailResponse.status,
          emailResponse.text
        );
        setStatus("Thank you for your message! We will get back to you soon.");
      } catch (emailError) {
        console.error("EmailJS error details:", {
          error: emailError,
          message: emailError.message,
          status: emailError.status,
          text: emailError.text,
        });

        // Check for specific Gmail scope error
        if (
          emailError.status === 412 &&
          emailError.text?.includes("insufficient authentication scopes")
        ) {
          console.warn(
            "Gmail API scope issue - email service needs proper permissions"
          );
          setStatus(
            "Thank you for your message! We have received your inquiry and will respond soon."
          );
        } else {
          setStatus(
            "Thank you for your message! We will get back to you soon. (Note: Email notification failed)"
          );
        }
      }

      setFormData({ fullName: "", email: "", phone: "", message: "" }); // Reset form
    } catch (error) {
      console.error("Submission error:", error);
      setStatus("Oops! Something went wrong. Please try again.");
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <div className="max-w-md   mt-8 mx-auto  ">
      <form onSubmit={handleSubmit}>
        <div className="mb-4">
          <input
            type="text"
            id="fullName"
            name="fullName"
            placeholder="Full Name"
            value={formData.fullName}
            onChange={handleChange}
            className="cursor-pointer mt-1 p-2 lg:p-4 lg:pl-8 pl-4 w-full border-2 border-blacklight rounded-full bg-bgWhite text-blacklight placeholder-blacklight
            focus:outline-none focus:border-primaryBlue   hover:border-primaryBlue hover:text-primaryBlue focus:text-primaryBlue "
            required
          />
        </div>
        <div className="mb-4">
          <input
            type="email"
            id="email"
            name="email"
            placeholder="Email"
            value={formData.email}
            onChange={handleChange}
            className="cursor-pointer  mt-1 p-2 lg:p-4 lg:pl-8 pl-4 w-full border-2 border-blacklight rounded-full focus:outline-none focus:border-primaryBlue hover:border-primaryBlue hover:text-primaryBlue focus:text-primaryBlue
             bg-bgWhite text-blacklight placeholder-blacklight"
            required
          />
        </div>
        <div className="mb-4">
          <input
            type="tel"
            id="phone"
            name="phone"
            placeholder="Phone"
            value={formData.phone}
            onChange={handleChange}
            className="mt-1 cursor-pointer  p-2 lg:p-4 lg:pl-8 pl-4 w-full border-2 border-blacklight rounded-full bg-bgWhite text-blacklight placeholder-blacklight
            focus:outline-none focus:border-primaryBlue hover:border-primaryBlue hover:text-primaryBlue focus:text-primaryBlue"
            required
          />
        </div>
        <div className="mb-4">
          <textarea
            id="message"
            name="message"
            placeholder="Message"
            value={formData.message}
            onChange={handleChange}
            className="mt-1 cursor-pointer   p-2 lg:p-4 lg:pl-8 pl-4 w-full border-2 border-blacklight rounded-xl bg-bgWhite text-blacklight placeholder-blacklight
            focus:outline-none focus:border-primaryBlue hover:border-primaryBlue hover:text-primaryBlue focus:text-primaryBlue"
            rows="4"
          ></textarea>
        </div>
        <div className="text-center">
          <button
            type="submit"
            disabled={isSubmitting}
            className="py-3 px-10 border-2 border-primaryBlue text-primaryBlue p-2 rounded-xl hover:bg-skyblue focus:outline-none focus:ring focus:border-blue-300 disabled:opacity-50 disabled:cursor-not-allowed"
          >
            {isSubmitting ? "Submitting..." : "Submit"}
          </button>
        </div>
        {status && (
          <p className="mt-4 text-center text-primaryBlue font-semibold">
            {status}
          </p>
        )}
      </form>
    </div>
  );
};

export default ContactForm;
